<template>
  <div>
    <div class="body-tool school-tool">
      <h2>推荐院校</h2>
      <span @click="toSchoolList">更多院校 &gt;</span>
    </div>
    <div class="con-list f-clearfix school-card">
      <ul class="index-school f-clearfix">
        <li
          class="f-clearfix"
          v-for="(item, index) in tableList"
          :key="index"
          :title="item.title"
          @click="toDetail(item)"
        >
          <div class="item-img">
            <img v-img.lazy="getUrl(item.logo)" alt />
          </div>
          <div class="item-content">
            <h3>{{ item.title }}</h3>
            <div class="item-count">
              <span class="item-school"
                >课程：{{
                  item.moocCourseCount + item.oocCourseCount || 0
                }}</span
              >
              <span class="item-edu"
                >学员：{{ item.totalEnrollCount || 0 }}
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div class="item-flex"></div>
      <div class="icon-btn icon-btn-left" @click="pageLeft('left')">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="icon-btn icon-btn-right" @click="pageLeft('right')">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [],
      schoolList: [],
      schoolWebLIst: [],
      pageFlag: 1,
      name: 1,
      clommAndCourse: [],
      tagMap: {},
      imgUrl: this.$setting.fdsDomain,
      pageList: {
        pageNo: 1,
        pageSize: 4,
        total: 0,
      },
    };
  },
  mounted() {
    this.name = this.$route.query.siteId || 1;
    this.getList();
  },
  methods: {
    getUrl(url) {
      if (!url) {
        return url;
      }
      if (url.startsWith("http")) {
        return url;
      } else {
        return this.imgUrl + url;
      }
    },
    toSchoolList(val) {
      // window.location.href = `/school`;
      window.open(`/school`);
    },
    pageLeft(val) {
      if (val == "left") {
        if (this.pageFlag > 1) {
          this.tableList = [];
          let item = [];
          this.pageFlag--;
          for (let i = (this.pageFlag - 1) * 4; i < this.pageFlag * 4; i++) {
            item.push(this.schoolWebLIst[i]);
          }
          this.tableList = item;
        }
      } else {
        if (this.pageFlag < Math.ceil(this.schoolWebLIst.length / 4)) {
          this.tableList = [];
          let item = [];
          for (let j = this.pageFlag * 4; j < (this.pageFlag + 1) * 4; j++) {
            if (j < this.schoolWebLIst.length) {
              item.push(this.schoolWebLIst[j]);
            }
          }
          this.tableList = item;
          this.pageFlag++;
        }
      }
    },
    toDetail(val) {

       let url = ''
      if(val.linkUrl.indexOf("/spoc/") != -1){
         url = val.linkUrl.replace("/spoc/","/")
      }else{
        url = val.linkUrl;
      }
      window.open(url);
    },
    getList() {
      this.tableMap = [];
      this.tableMapFlag = [];
      let par = {
        siteId: this.name,
        type: 2,
      };
      this.$http
        .get("/api/manager/customize/getInfo", { params: par })
        .then((res) => {
          this.$nextTick(() => {
            this.schoolList = JSON.parse(res.data.content) || [];
            let ids = [];
            for (let i = 0; i < this.schoolList.length; i++) {
              ids.push(this.schoolList[i].id);
            }
            if (this.schoolList && this.schoolList.length > 0) {
              this.getWebList(ids);
            }
            this.$emit("getSchool", this.schoolList.length > 0);
          });
        })
        .catch((msg) => {});
    },
    getWebList(ids) {
      let par = {
        ids: ids.toString(),
      };
      this.$http
        .get("/api/web/university/getListByIds", { params: par })
        .then((res) => {
          this.schoolWebLIst = res.data;
          for (let i = 0; i < 4; i++) {
            if (i < this.schoolWebLIst.length) {
              this.tableList.push(this.schoolWebLIst[i]);
            }
          }
        })
        .catch((msg) => {});
    },
  },
};
</script>
<style lang="scss">
.school-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  position: relative;
  h2 {
    flex: 1;
    max-width: 180px;
    min-width: 180px;
    padding: 0 20px;
    font-size: 18px;
    color: #333;
  }
  .item-flex {
    flex: 1;
    min-width: 70px;
    max-width: 70px;
  }
  .icon-btn {
    position: absolute;
    top: 50px;
    font-size: 32px;
    color: #fff;
    line-height: 60px;
    cursor: pointer;
    i {
      display: inline-block;
      background: #e5e6ebff;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-weight: bold;
    }
    &:hover {
      color: #3685fd;
    }
  }
  .icon-btn-left {
    left: -60px;
  }
  .icon-btn-right {
    right: -60px;
  }
}
// .con-list {
.index-school {
  overflow: hidden;
  white-space: nowrap;
  height: 100px;
  margin: 30px 0;
  min-width: 1200px;
  :nth-child(4n) {
    margin-right: 0px;
  }
  li {
    background: #fff;
    float: left;
    width: 280px;
    margin-right: 26px;
    height: 100px;
    display: flex;
    align-items: center;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    border-radius: 4px;
    cursor: pointer;

    .item-img {
      width: 80px;
      min-width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      margin-left: 10px;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.2s ease-in-out;
      }
      &:hover {
        img {
          opacity: 0.8;
          transform: scale(1.1);
          transition: all 0.4s ease-in-out;
        }
      }
    }

    .item-content {
      overflow: hidden;
      min-width: 190px;
      h3 {
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 40px;
        text-align: left;
        padding: 0 10px;
      }
    }
    div.item-btn {
      text-align: center;
      display: none;
    }
    div.item-count {
      display: flex;
      padding: 0 10px;
      justify-content: space-between;
      align-items: center;
      span {
        color: #777;
        font-size: 12px;
      }
      .item-school {
        max-width: 100px;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>
